import { NavLink } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

export function Nav() {
  const { user } = useAuth()
  
  if (!user) return null

  return (
    <nav className="bottom-nav">
      <NavLink to="/" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
        <span className="nav-icon">🏠</span>
        <span className="nav-label">Home</span>
      </NavLink>
      <NavLink to="/hotels" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
        <span className="nav-icon">🏨</span>
        <span className="nav-label">Hotels</span>
      </NavLink>
      <NavLink to="/history" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
        <span className="nav-icon">📋</span>
        <span className="nav-label">History</span>
      </NavLink>
      <NavLink to="/account" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
        <span className="nav-icon">👤</span>
        <span className="nav-label">Account</span>
      </NavLink>
    </nav>
  )
}
